<template>
  <div class="landing-wrapper">
    <TopBar />
    <LandingHeader />
    <main class="landing-content">
      <router-view />
    </main>
    <LandingFooter />
  </div>
</template>

<script>
import TopBar from "@/view/components/landing/TopBar.vue";
import LandingHeader from "@/view/components/landing/LandingHeader.vue";
import LandingFooter from "@/view/components/landing/LandingFooter.vue";

export default {
  name: "LandingLayout",
  components: {
    TopBar,
    LandingHeader,
    LandingFooter,
  },
  mounted() {
    document.documentElement.classList.add("landing-page");
    document.body.classList.add("landing-page");
  },
  beforeDestroy() {
    document.documentElement.classList.remove("landing-page");
    document.body.classList.remove("landing-page");
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/landing/landing.scss";
</style>
